'use client';

import { StickyNote } from 'lucide-react';
import { useInternalNotesContext } from 'src/shared/components/internal-notes/InternalNotesContext';
import NoteItem from 'src/shared/components/internal-notes/NoteItem';
import AnimatedEllipsis from 'src/shared/components/ui/loaders/animated-ellipsis';

export default function NoteList() {
  const { notes, isPending, isComposing } = useInternalNotesContext();

  if (isPending) {
    return (
      <div className="px-4 py-6 text-typography-grey">
        <AnimatedEllipsis />
      </div>
    );
  }

  if (!notes?.length && !isComposing) {
    return (
      <div className="flex flex-col items-center justify-center h-full gap-2 py-12 text-typography-grey">
        <StickyNote size={24} />
        <p className="text-sm">No notes yet</p>
      </div>
    );
  }

  if (!notes?.length) {
    return null;
  }

  return (
    <div className="flex flex-col gap-1">
      {notes.map((note) => (
        <NoteItem key={note.id} note={note} />
      ))}
    </div>
  );
}
